import { render, staticRenderFns } from "./VContactFilter.vue?vue&type=template&id=04044300&"
import script from "./VContactFilter.vue?vue&type=script&lang=js&"
export * from "./VContactFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports